import { createStore } from "vuex";
import UnitTitlesJson from "@/assets/json/unit_titles.json";

export default createStore({
  state: {
    subject: UnitTitlesJson.subject,
    //ダークモードフラグ
    isDarkMode: false,
    //アイコン画像
    iconImg:{
      lightMovieImg: require("../assets/images/icon_movie_img.png"),
      lightSoundImg: require("../assets/images/icon_sound_img.png"),
      lightSimulationImg: require("../assets/images/icon_simulation_img.png"),
      lightWorkImg: require("../assets/images/icon_work_img.png"),
      lightDocumentImg: require("../assets/images/icon_document_img.png"),
      lightPracticeImg: require("../assets/images/icon_practice_img.png"),
      lightProgramImg: require("../assets/images/icon_program_img.png"),
      lightWebImg: require("../assets/images/icon_web_img.png"),
      lightLinkImg: require("../assets/images/icon_link_img.png"),
      lightTabletImg: require("../assets/images/icon_tablet_img.png"),
      lightStarImg: require("../assets/images/icon_star_img.png"),
      lightThinkingImg: require("../assets/images/icon_thinking_img.png"),
      lightVrImg: require("../assets/images/icon_vr_img.png"),
      lightCleanImg: require("../assets/images/icon_clean_img.png"),
      lightConjugationImg: require("../assets/images/icon_conjugation_img.png"),
      lightSdgsImg: require("../assets/images/icon_sdgs_img.png"),
      lightQuizImg: require("../assets/images/icon_quiz_img.png"),
      lightMapImg: require("../assets/images/icon_map_img.png"),
      lightSupplementImg: require("../assets/images/icon_supplement_img.png"),
      lightExercisesImg: require("../assets/images/icon_exercises_img.png"),
      lightSlideImg: require("../assets/images/icon_slide_img.png"),
      lightLawImg: require("../assets/images/icon_law_img.png"),
      lightExistingWebImg: require("../assets/images/icon_existing_web_img.png"),
      lightExistingSimulationImg: require("../assets/images/icon_existing_simulation_img.png"),
      lightExistingLinkImg: require("../assets/images/icon_existing_link_img.png"),
      lightExistingMovieImg: require("../assets/images/icon_existing_movie_img.png"),
      darkMovieImg: require("../assets/images/icon_movie_dark_img.png"),
      darkSoundImg: require("../assets/images/icon_sound_dark_img.png"),
      darkSimulationImg: require("../assets/images/icon_simulation_dark_img.png"),
      darkWorkImg: require("../assets/images/icon_work_dark_img.png"),
      darkDocumentImg: require("../assets/images/icon_document_dark_img.png"),
      darkPracticeImg: require("../assets/images/icon_practice_dark_img.png"),
      darkProgramImg: require("../assets/images/icon_program_dark_img.png"),
      darkWebImg: require("../assets/images/icon_web_dark_img.png"),
      darkLinkImg: require("../assets/images/icon_link_dark_img.png"),
      darkTabletImg: require("../assets/images/icon_tablet_dark_img.png"),
      darkStarImg: require("../assets/images/icon_star_dark_img.png"),
      darkThinkingImg: require("../assets/images/icon_thinking_dark_img.png"),
      darkVrImg: require("../assets/images/icon_vr_dark_img.png"),
      darkCleanImg: require("../assets/images/icon_clean_dark_img.png"),
      darkConjugationImg: require("../assets/images/icon_conjugation_dark_img.png"),
      darkSdgsImg: require("../assets/images/icon_sdgs_dark_img.png"),
      darkQuizImg: require("../assets/images/icon_quiz_dark_img.png"),
      darkMapImg: require("../assets/images/icon_map_dark_img.png"),
      darkSupplementImg: require("../assets/images/icon_supplement_dark_img.png"),
      darkExercisesImg: require("../assets/images/icon_exercises_dark_img.png"),
      darkSlideImg: require("../assets/images/icon_slide_dark_img.png"),
      darkLawImg: require("../assets/images/icon_law_dark_img.png"),
      darkExistingWebImg: require("../assets/images/icon_existing_web_img.png"),
      darkExistingSimulationImg: require("../assets/images/icon_existing_simulation_img.png"),
      darkExistingLinkImg: require("../assets/images/icon_existing_link_img.png"),
      darkExistingMovieImg: require("../assets/images/icon_existing_movie_img.png"),
    },
    textImg:[
      "test01",
      "test02",
    ],
    isTransitionSideMenu: false,
  },
  //isDarkMode切り替わり検知
  mutations: {
    toggleDarkMode(state, toggleValue) {
      state.isDarkMode = toggleValue;
    },
    setTransitionSideMenu(state, value) {
      state.isTransitionSideMenu = value;
    },
  },
  actions: {},
  modules: {},
});
